(() => {
  const roomConfig = {
    Small: { range: 'up to 75 sq ft', gentle: 36, balanced: 36, strong: 42 },
    Medium: { range: '76-176 sq ft', gentle: 42, balanced: 52, strong: 60 },
    Large: { range: '176-350 sq ft', gentle: 52, balanced: 60, strong: 70 },
    'Open Plan': { range: '350+ sq ft', gentle: 60, balanced: 70, strong: 82 },
  };
  const init = (finder) => {
    if (finder.dataset.ready) return;
    finder.dataset.ready = 'true';
    const abort = new AbortController();
    const controller = () => window.XCWVariantContent?.get(finder.dataset.productId);
    let recommended;
    const update = () => {
      const owner = controller();
      const state = owner?.state;
      const room = finder.querySelector('[data-xp-room].is-active');
      const height = finder.querySelector('[data-xp-height].is-active');
      const breeze = finder.querySelector('[data-xp-airflow].is-active');
      if (!room || !height || !breeze) return;
      const choice = roomConfig[room.dataset.roomLabel];
      const size = choice[breeze.dataset.xpAirflow];
      recommended = state?.variant && owner.config.variants.find((variant) =>
        Number.parseInt(variant.options[owner.sizeIndex], 10) === size &&
        variant.options.every((value, index) => index === owner.sizeIndex || value === state.variant.options[index]));
      const profile = recommended ? owner.profile(recommended) : {};
      finder.querySelector('[data-xp-current-color]').textContent = state?.color || 'Choose above';
      finder.querySelector('[data-xp-recommend-size]').textContent = `${size} inch`;
      finder.querySelector('[data-xp-room-result]').textContent = `Suggested for rooms ${choice.range}`;
      finder.querySelector('[data-xp-downrod-result]').textContent = profile.downrods
        ? `Included downrods: ${profile.downrods}. Choose for your ceiling height and required clearance.`
        : 'Check the included downrods and installation clearance for this size.';
      finder.querySelector('[data-xp-airflow-result]').textContent = `${breeze.textContent.trim()} airflow preference`;
      const cfm = finder.querySelector('[data-xp-cfm-result]');
      cfm.textContent = profile.airflow ? `Maximum airflow: ${profile.airflow}` : '';
      cfm.hidden = !profile.airflow;
      const button = finder.querySelector('[data-xp-apply]');
      if (button) button.disabled = !recommended?.available;
      const result = finder.querySelector('[data-xp-result]');
      result.classList.toggle('is-unavailable', !recommended?.available);
      result.textContent = recommended?.available
        ? `Recommended: ${recommended.options.join(' / ')}. Apply this size to your selection above.`
        : `The recommended ${size}-inch size is unavailable for your selected options. Choose another size above.`;
    };
    for (const selector of ['[data-xp-room]', '[data-xp-height]', '[data-xp-airflow]']) {
      finder.querySelectorAll(selector).forEach((button) => button.addEventListener('click', () => {
        finder.querySelectorAll(selector).forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
        finder.querySelector('[data-xp-apply-status]')?.replaceChildren();
        update();
      }));
    }
    finder.querySelector('[data-xp-apply]')?.addEventListener('click', () => {
      const owner = controller();
      if (!recommended?.available || !owner?.select(recommended.id)) return;
      const status = finder.querySelector('[data-xp-apply-status]');
      if (status) status.textContent = `Applied ${recommended.options.join(' / ')}. Complete your purchase above.`;
      const picker = owner.picker();
      picker?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      picker?.querySelector('input:checked, select')?.focus({ preventScroll: true });
    });
    document.addEventListener('xcw:content-update', (event) => {
      if (!finder.isConnected) { abort.abort(); return; }
      if (event.detail.productId === finder.dataset.productId) update();
    }, { signal: abort.signal });
    update();
  };
  const initAll = () => document.querySelectorAll('[data-xp-size-finder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
